import React from 'react';
import styles from '../UserInfo.styles';
import ListItem from '../../../shared/ListItem';
import { Collapse } from 'antd';
import { renderText } from '../../../shared/DrawerLayout/renderText';
import formatDateTime from '../../../../utils/formatDateTime';

interface UserIdentityInfoProps {
  selectedUser: any;
  intl: any;
}

const { Panel } = Collapse;

const UserOrgRepresentativesInfo: React.FC<UserIdentityInfoProps> = ({
  selectedUser,
  intl,
}) => {
  const orgRepresentatives = selectedUser?.orgData?.representativePersons;

  const representatives = orgRepresentatives?.map(
    (rep) => `${rep.mdFirstname} ${rep.mdLastname}`
  );

  const lastPdfUpdate = selectedUser?.orgData?.legalEntityPdfUrlUpdatedAt;

  return (
    <>
      <div className="collapse-container">
        <div className="collapse-duplicates-container">
          <Collapse bordered={false}>
            <Panel
              header={intl.formatMessage({
                id: 'fleetadmin.users.org.registration.data',
              })}
              key="user-id"
            >
              <ListItem
                label={intl.formatMessage({
                  id: 'fleetadmin.users.org.representatives',
                })}
                value={representatives?.map((rep, index) => (
                  <div key={index}>{renderText(rep)}</div>
                ))}
              />

              <ListItem
                label={intl.formatMessage({
                  id: 'fleetadmin.users.org.last.pdf.update',
                })}
                value={formatDateTime(lastPdfUpdate)}
              />
            </Panel>
          </Collapse>
        </div>
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default UserOrgRepresentativesInfo;
